import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import LicenseSeatsDialog, {
  getLicenseSeatsDialogTitle,
} from "@/v2-backoffice-client/license/seats/LicenseSeatsDialog"
import type { LicenseFragment } from "@/v2-backoffice-client/license/__types__/license.fragment"

export type LicenseSeatsMenuItemProps = Omit<ActionMenuItemProps, "onClick"> & {
  license: LicenseFragment
}

// The license row menu's entry to the seat cap dialog (LicenseSeatsDialog
// says what the cap means per license owner). The customer panel's seat
// warning opens the same dialog from a button.
function LicenseSeatsMenuItem(props: LicenseSeatsMenuItemProps) {
  const { license, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="users-alt"
        data-feature-code="UI_BackofficeLicense_Row_Seats"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? getLicenseSeatsDialogTitle(license)}
      </ActionMenu.Item>

      {/* Mounted per open so the field re-seeds from the license every time. */}
      {isOpen && (
        <LicenseSeatsDialog
          license={license}
          open={isOpen}
          onOpenChange={setIsOpen}
        />
      )}
    </>
  )
}

export default LicenseSeatsMenuItem
